module.exports = __webpack_public_path__ + "static/images/containers/PostbattleScreen/components/BattleList/images/background-defeat.c7dfae66.png";


//////////////////
// WEBPACK FOOTER
// ./containers/PostbattleScreen/components/BattleList/images/background-defeat.png
// module id = 3208
// module chunks = 11